module.exports = __webpack_public_path__ + "img/var_02_base2.829501d1.png";